import { ULThemeButton } from "@/components/ULThemeButton";

import { useMfaOtpChallengeManager } from "../hooks/useMfaOtpChallengeManager";

function Footer() {
  const { texts, handleTryAnotherMethod, locales } =
    useMfaOtpChallengeManager();

  const tryAnotherMethodText =
    texts?.pickAuthenticatorText || locales?.footer?.tryAnotherMethod;

  // ⚠️ THIS LINK LEAVES THE ACUL BUNDLE. tryAnotherMethod() navigates to
  // `mfa-login-options`, which is NOT in advanced mode, so the member lands on
  // a stock Auth0 factor picker mid-journey. That is a deliberate, recorded
  // trade-off rather than an oversight — see ARCHITECTURE.md, "The factor
  // picker is stock".
  //
  // It is still rendered, because the alternative is worse: this tenant enables
  // `recovery-code` alongside `otp`, and the step-up branch challenges with
  // challengeWithAny([otp, recovery-code]). Removing this link would strand a
  // member who has lost their authenticator but holds a recovery code
  // generated from My Account, with no way to reach it.
  const handleClick = async () => {
    await handleTryAnotherMethod();
  };

  return (
    <div className="text-center mt-4">
      <ULThemeButton onClick={handleClick} variant="link" size="link">
        {tryAnotherMethodText}
      </ULThemeButton>
    </div>
  );
}

export default Footer;
